$(function () {
    if ($('[data-container="rice-information"]').length) {
        initHolizontalGauge();
        initRiceMap();
        $(window).on('resize', function () {
            initHolizontalGauge();
        });
    }
});
const minValue = 0;
const maxValue = 10;
var initHolizontalGauge = function () {
    $('.horizontal-gauge-container').each(function () {
        let self = this;
        let gaugeContainer = $('.horizontal-gauge', self);
        let gaugeIndicator = $('.gauge-indicator', self);
        let gaugeValue = parseFloat(gaugeContainer.attr('data-gauge-value'));
        let percentage = (gaugeValue - minValue) / (maxValue - minValue) * 100;
        let indicatorWidth = gaugeIndicator.width();
        let leftPosition = (percentage * gaugeContainer.width() / 100) - (indicatorWidth / 2);
        gaugeIndicator.css("left", `${leftPosition}px`);
    })
}
var initRiceMap = function () {
    if ($('#rice-region-map[data-region]').length) {
        let regionName = $('#rice-region-map').attr('data-region');
        console.log(regionName);
        $('#' + regionName).addClass("region-active");
    }
}